import React from 'react';

// Diferencia visualmente el lado de la operación mientras la caución está en
// gestión. Una vez "Hecha", el lado deja de ser accionable y se muestra texto plano.
const palette = {
    Tomadora: { bg: '#E8EDF5', text: '#1A283E', border: '#1A283E', arrow: '▼' },
    Colocadora: { bg: '#EEF2FF', text: '#4338CA', border: '#4F46E5', arrow: '▲' },
};

const OperacionBadge = ({ operacion, estado }) => {
    const colors = palette[operacion];

    if (estado === 'Hecha' || !colors) {
        return operacion || '-';
    }

    return (
        <span
            title={`Caución ${operacion}`}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.3rem',
                padding: '0.15rem 0.5rem',
                borderRadius: '4px',
                border: `1px solid ${colors.border}`,
                backgroundColor: colors.bg,
                color: colors.text,
                fontSize: '0.78rem',
                fontWeight: 700,
                lineHeight: 1.15,
                whiteSpace: 'nowrap',
            }}
        >
            <span aria-hidden="true">{colors.arrow}</span>
            {operacion}
        </span>
    );
};

export default OperacionBadge;
